// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Public pages
import HomePage from './pages/HomePage';
import ExperiencePage from './pages/ExperiencePage';
import SkillsPage from './pages/SkillsPage';
import EducationPage from './pages/EducationPage';
import PublicationsPage from './pages/PublicationsPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import JwtTestPage from './pages/JwtTestPage';

// Admin pages
import AdminExperiencePage from './pages/AdminExperiencePage';
import AdminSkillsPage from './pages/AdminSkillsPage';
import AdminPublicationsPage from './pages/AdminPublicationsPage';
import AdminEducationPage from './pages/AdminEducationPage';
import AdminFooterPage from './pages/AdminFooterPage';   // NEW

function App() {
  return (
    <AuthProvider>
      <Router>
        <CssBaseline />
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}>
          <Navbar />

          <Box component="main" sx={{ flexGrow: 1, px: { xs: 2, sm: 3 }, py: 3 }}>
            <Routes>
              {/* Public routes */}
              <Route path="/"             element={<HomePage />} />
              <Route path="/experience"   element={<ExperiencePage />} />
              <Route path="/skills"       element={<SkillsPage />} />
              <Route path="/education"    element={<EducationPage />} />
              <Route path="/publications" element={<PublicationsPage />} />
              <Route path="/contact"      element={<ContactPage />} />
              <Route path="/login"        element={<LoginPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              <Route path="/test/jwt"     element={<JwtTestPage />} />

              {/* Protected routes */}
              <Route path="/admin/experience" element={
                <ProtectedRoute roles={['admin', 'editor']}>
                  <AdminExperiencePage />
                </ProtectedRoute>
              } />
              <Route path="/admin/skills" element={
                <ProtectedRoute roles={['admin', 'editor']}>
                  <AdminSkillsPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/publications" element={
                <ProtectedRoute roles={['admin', 'editor']}>
                  <AdminPublicationsPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/education" element={
                <ProtectedRoute roles={['admin', 'editor']}>
                  <AdminEducationPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/footer" element={        /* NEW */
                <ProtectedRoute roles={['admin', 'editor']}>
                  <AdminFooterPage />
                </ProtectedRoute>
              } />

              {/* 404 */}
              <Route path="*" element={
                <Box sx={{ textAlign: 'center', py: 8 }}>
                  <h1>404: Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                </Box>
              } />
            </Routes>
          </Box>

          <Footer />
        </Box>
      </Router>
    </AuthProvider>
  );
}

export default App;
